import { Product } from '../types'

export const products: Product[] = [
  {
    id: 'sca',
    slug: 'sca',
    name: 'D-TECH SCA',
    model: 'STANDARD',
    series: 'sca',
    badge: 'Za teške terete',
    badgeEn: 'Heavy duty',
    badgeRu: 'Для тяжёлых грузов',
    price: 1890,
    description:
      'Industrijska verzija za teške uslove rada. Stabilna na grubim stepenicama i podlogama zahvaljujući sistemu sa pogonskim točkovima prilagođenim za savladavanje visinskih razlika.',
    descriptionEn:
      'Industrial version for heavy-duty working conditions. Stable on rough stairs and rugged surfaces thanks to a drive wheel system designed to overcome height differences.',
    descriptionRu:
      'Промышленная версия для тяжёлых условий эксплуатации. Устойчива на грубых лестницах и неровных поверхностях благодаря системе ведущих колёс, рассчитанной на преодоление перепадов высоты.',
    image:
      'https://cdn.magicpatterns.com/uploads/rf5NrgHygwqJiVRF6Ubzv8/SCA_za_sajt.jpg',
    gallery: [
      {
        type: 'video',
        url: 'https://cdn.magicpatterns.com/uploads/mSYYNkJyukoDMZMh7e8PPt/SCA.mp4',
      },
      {
        type: 'image',
        url: 'https://cdn.magicpatterns.com/uploads/fiFTm5CkJjaa2vxi6jT12K/2.jpg',
      },
      {
        type: 'image',
        url: 'https://cdn.magicpatterns.com/uploads/cjwunoexxNR1kMK1aoVNDE/3.jpg',
      },
    ],
    specs: {
      capacity: '150 – 180 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (1 baterija)',
      batteryEn: '48V 36Ah lithium (1 battery)',
      batteryRu: '48В 36Ач литий (1 аккумулятор)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      climbingSpeedEn: 'Variable speed control',
      climbingSpeedRu: 'Плавная регулировка скорости',
      size: '65 x 56 x 120-180 cm',
      foldingThickness: '35 cm',
      weight: '35 kg',
      leadTime: 'Dostupnost na upit (4–8 nedelja iz proizvodnje)',
      leadTimeEn: 'Availability on request (4–8 weeks from production)',
      leadTimeRu: 'Наличие по запросу (4–8 недель с производства)',
    },
    features: [
      'Dva velika zadnja pogonska točka za stabilnost',
      'Električna kočnica za kontrolu na nagibu',
      'Beskrajna regulacija brzine',
      'Sklopiva konstrukcija',
      'Litijumska baterija (do 4h rada)',
      'Namenjen za građevinski sektor',
    ],
    featuresEn: [
      'Two large rear drive wheels for stability',
      'Electric brake for incline control',
      'Variable speed control',
      'Foldable construction',
      'Lithium battery (up to 4h runtime)',
      'Designed for the construction sector',
    ],
    featuresRu: [
      'Два больших задних ведущих колеса для устойчивости',
      'Электрический тормоз для контроля на наклоне',
      'Плавная регулировка скорости',
      'Складная конструкция',
      'Литиевый аккумулятор (до 4 ч работы)',
      'Предназначена для строительного сектора',
    ],
    highlights: [
      'Dva pogonska točka za stabilnost',
      'Električna kočnica',
      'Sistem za savladavanje visinskih razlika',
    ],
    highlightsEn: [
      'Two drive wheels for stability',
      'Electric brake',
      'System for overcoming height differences',
    ],
    highlightsRu: [
      'Два ведущих колеса для устойчивости',
      'Электрический тормоз',
      'Система преодоления перепадов высоты',
    ],
  },
  {
    id: 'standard',
    slug: 'standard',
    name: 'D-TECH SCB',
    model: 'STANDARD',
    series: 'scb',
    price: 2090,
    description:
      'Osnovna konfiguracija za svakodnevnu profesionalnu upotrebu. Pouzdan transport tereta uz stepenice.',
    descriptionEn:
      'Basic configuration for daily professional use. Reliable cargo transport on stairs.',
    descriptionRu:
      'Базовая конфигурация для ежедневного профессионального использования. Надёжная транспортировка грузов по лестницам.',
    image:
      'https://cdn.magicpatterns.com/uploads/2JFxrQoz9bUYCTY3p3fnnv/DTECH_STANDARD.jpg',
    specs: {
      capacity: '150 – 200 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (1 baterija)',
      batteryEn: '48V 36Ah lithium (1 battery)',
      batteryRu: '48В 36Ач литий (1 аккумулятор)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      climbingSpeedEn: 'Variable speed control',
      climbingSpeedRu: 'Плавная регулировка скорости',
      size: '65 x 56 x 120-180 cm',
      foldingThickness: '35 cm',
      weight: '37 kg',
      leadTime: 'Dostupnost na upit (4–8 nedelja iz proizvodnje)',
      leadTimeEn: 'Availability on request (4–8 weeks from production)',
      leadTimeRu: 'Наличие по запросу (4–8 недель с производства)',
    },
    features: [
      'Električna kočnica za kontrolu na nagibu',
      'Automatski gas sa manuelnom kontrolom',
      'Podesiva ručka za visinu',
      'Beskrajna regulacija brzine',
      'Industrijska mat boja',
      'Kompaktan sklopivi dizajn',
      'Brza zamena baterije',
      'Litijumska baterija (do 4h rada)',
    ],
    featuresEn: [
      'Electric brake for incline control',
      'Automatic throttle with manual control',
      'Adjustable handle height',
      'Variable speed control',
      'Industrial matte paint',
      'Compact foldable design',
      'Quick battery replacement',
      'Lithium battery (up to 4h runtime)',
    ],
    featuresRu: [
      'Электрический тормоз для контроля на наклоне',
      'Автоматический газ с ручным управлением',
      'Регулируемая по высоте ручка',
      'Плавная регулировка скорости',
      'Промышленная матовая окраска',
      'Компактная складная конструкция',
      'Быстрая замена аккумулятора',
      'Литиевый аккумулятор (до 4 ч работы)',
    ],
    highlights: [
      '1 baterija 48V 36Ah',
      'Visokokvalitetne gumene gusenice za maksimalno prianjanje',
      'Industrijska mat boja',
      'Električna kočnica',
    ],
    highlightsEn: [
      '1 battery 48V 36Ah',
      'High-quality rubber tracks for maximum grip',
      'Industrial matte paint',
      'Electric brake',
    ],
    highlightsRu: [
      '1 аккумулятор 48В 36Ач',
      'Высококачественные резиновые гусеницы для максимального сцепления',
      'Промышленная матовая окраска',
      'Электрический тормоз',
    ],
  },
  {
    id: 'standard-plus',
    slug: 'standard-plus',
    name: 'D-TECH SCB',
    model: 'STANDARD+',
    series: 'scb',
    comingSoon: true,
    price: 2190,
    description:
      'Standard sa dodatnim zaštitnim neklizajućim slojem za povećanu stabilnost u zahtevnim uslovima.',
    descriptionEn:
      'Standard with an additional protective non-slip layer for increased stability in demanding conditions.',
    descriptionRu:
      'Стандарт с дополнительным защитным противоскользящим слоем для повышенной устойчивости в сложных условиях.',
    image:
      'https://cdn.magicpatterns.com/uploads/m5nEPzJD6tLEnedUiegTe9/basic_1.jpg',
    specs: {
      capacity: '180 – 220 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (1 baterija)',
      batteryEn: '48V 36Ah lithium (1 battery)',
      batteryRu: '48В 36Ач литий (1 аккумулятор)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      climbingSpeedEn: 'Variable speed control',
      climbingSpeedRu: 'Плавная регулировка скорости',
      size: '65 x 56 x 120-180 cm',
      foldingThickness: '35 cm',
      weight: '40 kg',
      leadTime: 'Dostupnost na upit (4–8 nedelja iz proizvodnje)',
      leadTimeEn: 'Availability on request (4–8 weeks from production)',
      leadTimeRu: 'Наличие по запросу (4–8 недель с производства)',
    },
    features: [
      'Zaštitni neklizajući sloj',
      'Električna kočnica za kontrolu na nagibu',
      'Automatski gas sa manuelnom kontrolom',
      'Podesiva ručka za visinu',
      'Beskrajna regulacija brzine',
      'Kompaktan sklopivi dizajn',
      'Brza zamena baterije',
      'Litijumska baterija (do 4h rada)',
    ],
    featuresEn: [
      'Protective non-slip layer',
      'Electric brake for incline control',
      'Automatic throttle with manual control',
      'Adjustable handle height',
      'Variable speed control',
      'Compact foldable design',
      'Quick battery replacement',
      'Lithium battery (up to 4h runtime)',
    ],
    featuresRu: [
      'Защитный противоскользящий слой',
      'Электрический тормоз для контроля на наклоне',
      'Автоматический газ с ручным управлением',
      'Регулируемая по высоте ручка',
      'Плавная регулировка скорости',
      'Компактная складная конструкция',
      'Быстрая замена аккумулятора',
      'Литиевый аккумулятор (до 4 ч работы)',
    ],
    highlights: [
      '1 baterija 48V 36Ah',
      'Zaštitni neklizajući sloj',
      'Električna kočnica',
    ],
    highlightsEn: [
      '1 battery 48V 36Ah',
      'Protective non-slip layer',
      'Electric brake',
    ],
    highlightsRu: [
      '1 аккумулятор 48В 36Ач',
      'Защитный противоскользящий слой',
      'Электрический тормоз',
    ],
  },
  {
    id: 'raptor',
    slug: 'raptor',
    name: 'D-TECH RAPTOR',
    model: 'HEAVY DUTY',
    series: 'scb',
    price: 2290,
    description:
      'Premium konfiguracija sa zaštitnom bojom otpornom na habanje i dve baterije za produženi rad.',
    descriptionEn:
      'Premium configuration with wear-resistant protective paint and two batteries for extended operation.',
    descriptionRu:
      'Премиальная конфигурация с защитной износостойкой окраской и двумя аккумуляторами для продолжительной работы.',
    image:
      'https://cdn.magicpatterns.com/uploads/qLkakcP4DrV2Dp874ZqZ5Q/RPT.jpg',
    specs: {
      capacity: '200 – 250 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (2 baterije)',
      batteryEn: '48V 36Ah lithium (2 batteries)',
      batteryRu: '48В 36Ач литий (2 аккумулятора)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      climbingSpeedEn: 'Variable speed control',
      climbingSpeedRu: 'Плавная регулировка скорости',
      size: '65 x 56 x 120-180 cm',
      foldingThickness: '35 cm',
      weight: '40 kg',
      leadTime: 'Dostupnost na upit (4–8 nedelja iz proizvodnje)',
      leadTimeEn: 'Availability on request (4–8 weeks from production)',
      leadTimeRu: 'Наличие по запросу (4–8 недель с производства)',
    },
    features: [
      'Zaštitna boja otporna na habanje',
      'Dve litijumske baterije za produženi rad',
      'Brza zamena baterije',
      'Električna kočnica za kontrolu na nagibu',
      'Automatski gas sa manuelnom kontrolom',
      'Podesiva ručka za visinu',
      'Beskrajna regulacija brzine',
      'Kompaktan sklopivi dizajn',
    ],
    featuresEn: [
      'Wear-resistant protective paint',
      'Two lithium batteries for extended operation',
      'Quick battery replacement',
      'Electric brake for incline control',
      'Automatic throttle with manual control',
      'Adjustable handle height',
      'Variable speed control',
      'Compact foldable design',
    ],
    featuresRu: [
      'Защитная износостойкая окраска',
      'Два литиевых аккумулятора для продолжительной работы',
      'Быстрая замена аккумулятора',
      'Электрический тормоз для контроля на наклоне',
      'Автоматический газ с ручным управлением',
      'Регулируемая по высоте ручка',
      'Плавная регулировка скорости',
      'Компактная складная конструкция',
    ],
    highlights: [
      '2 baterije 48V 36Ah',
      'Visokokvalitetne gumene gusenice za maksimalno prianjanje',
      'Boja otporna na habanje',
      'Električna kočnica',
    ],
    highlightsEn: [
      '2 batteries 48V 36Ah',
      'High-quality rubber tracks for maximum grip',
      'Wear-resistant paint',
      'Electric brake',
    ],
    highlightsRu: [
      '2 аккумулятора 48В 36Ач',
      'Высококачественные резиновые гусеницы для максимального сцепления',
      'Износостойкая окраска',
      'Электрический тормоз',
    ],
  },
  {
    id: 'scc-pro',
    slug: 'scc-pro',
    name: 'D-TECH SCC',
    model: 'PRO',
    series: 'scc',
    price: 0,
    priceLabel: 'Uskoro dostupno',
    priceLabelEn: 'Coming soon',
    priceLabelRu: 'Скоро',
    description:
      'Napredni model za profesionalnu upotrebu. Pojačane gumene gusenice i hidraulično-elektromagnetna potporna šipka obezbeđuju veću stabilnost i sigurnost pri transportu težih tereta.',
    descriptionEn:
      'Advanced model for professional use. Reinforced rubber tracks and a hydraulic-electromagnetic support rod provide greater stability and safety when transporting heavier loads.',
    descriptionRu:
      'Продвинутая модель для профессионального использования. Усиленные резиновые гусеницы и гидравлическо-электромагнитный опорный стержень обеспечивают большую устойчивость и безопасность при транспортировке тяжёлых грузов.',
    image:
      'https://cdn.magicpatterns.com/uploads/hggMGv5HaYSpxFwXnwmnHo/SCC_PRO.png',
    specs: {
      capacity: '400 kg',
      motor: '1500W',
      battery: '48V',
      batteryEn: '48V',
      batteryRu: '48В',
      chargingTime: '4h',
      climbingSpeed: '4-5 sati rada',
      climbingSpeedEn: '4-5 hours working time',
      climbingSpeedRu: '4-5 часов работы',
      size: '110 x 65 x 52 cm (pakovanje)',
      foldingThickness: '52 cm',
      weight: '88 kg',
      leadTime: 'Dostupnost na upit',
      leadTimeEn: 'Availability on request',
      leadTimeRu: 'Наличие по запросу',
    },
    features: [
      'Pojačane gumene gusenice za maksimalno prianjanje',
      'Žiroskopski sistem za balans i centriranje tereta',
      'Hidraulično-elektromagnetna potporna šipka',
      'Snažan motor od 1500W',
      'Nosivost do 400 kg',
      'Radno vreme 4-5 sati',
      'Kompaktno pakovanje',
    ],
    featuresEn: [
      'Reinforced rubber tracks for maximum grip',
      'Gyroscopic load balancing and centering system',
      'Hydraulic-electromagnetic support rod',
      'Powerful 1500W motor',
      'Load capacity up to 400 kg',
      'Working time 4-5 hours',
      'Compact packaging',
    ],
    featuresRu: [
      'Усиленные резиновые гусеницы для максимального сцепления',
      'Гироскопическая система балансировки и центрирования груза',
      'Гидравлическо-электромагнитный опорный стержень',
      'Мощный двигатель 1500 Вт',
      'Грузоподъемность до 400 кг',
      'Время работы 4-5 часов',
      'Компактная упаковка',
    ],
    highlights: [
      'Žiroskopski balans i centriranje',
      'Pojačane gusenice',
      'Nosivost 400 kg',
      'Hidraulično-elektromagnetna podrška',
    ],
    highlightsEn: [
      'Gyroscopic balancing & centering',
      'Reinforced tracks',
      '400 kg capacity',
      'Hydraulic-electromagnetic support',
    ],
    highlightsRu: [
      'Гироскопическая балансировка и центрирование',
      'Усиленные гусеницы',
      'Грузоподъемность 400 кг',
      'Гидравлическо-электромагнитная поддержка',
    ],
  },
]

export const scaProducts = products.filter((p) => p.series === 'sca')
export const scbProducts = products.filter((p) => p.series === 'scb')
export const sccProducts = products.filter((p) => p.series === 'scc')

export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug)
}
